var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftMob = function SvgLeftMob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 51 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#leftMob_svg__a)",
    strokeLinecap: "round",
    d: "M49.17 3.672H.668",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B0AB",
    d: "M47.497.672 50.325 3.5l-2.829 2.828L44.668 3.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "leftMob_svg__a",
    x1: 1.168,
    x2: 49.17,
    y1: 3.672,
    y2: 3.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
export default SvgLeftMob;